import React from 'react';
import { Hero } from '@/components/sections/Hero';
import { Proof } from '@/components/sections/Proof';
import { ExecutiveProfile } from '@/components/sections/ExecutiveProfile';
import { AdvisoryServices } from '@/components/sections/AdvisoryServices';
import { TechStack } from '@/components/sections/TechStack';
import { AiChatDemo } from '@/components/sections/AiChatDemo';
import { Engagement } from '@/components/sections/Engagement';
import { Contact } from '@/components/sections/Contact';

export const HomePage: React.FC = () => {
  return (
    <main>
      <Hero />
      <Proof />
      <ExecutiveProfile />
      <AdvisoryServices />
      <TechStack />
      <AiChatDemo />
      <Engagement />
      <Contact />
    </main>
  );
};

export default HomePage;
